<script setup>
import { DEFAULT_SORT } from '@phoenix/helpers/mixed-grid-helper';
import MixedGridFilters from '../mixedGrid/MixedGridFilters.vue';
import uniqueId from 'lodash-es/uniqueId';
import { computed, toRef, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  facets: {
    type: Array,
    required: true,
  },
  productsCount: {
    type: Number,
    default: 0,
  },
});

const store = useStore();
const { t } = useI18n();

const facets = toRef(props, 'facets');
const filtersInitialized = ref(false);
const mixedGridFiltersRef = ref(null);
const defaultSort = DEFAULT_SORT;
const id = uniqueId('search-results-products');
const sellableFilterId = `sellable--${window.Phoenix.currentCountry}`;
const shouldDisplaySellable = computed(
  () => Array.isArray(facets.value) && facets.value.find((filter) => filter.id === sellableFilterId) !== undefined,
);
const query = computed(() => store.state.search.query);
const filters = computed(() => {
  const filters = Array.isArray(facets.value) ? facets.value : [];

  const sellableFilter = filters.find((filter) => filter.id === sellableFilterId);

  //Not so clean, could be better with a CustomFilter as done with image (Panel filter)
  if (sellableFilter) {
    const item = sellableFilter.items.find((item) => item.value === 'true');
    const customSellableFilter = {
      ...sellableFilter,
      items: [
        {
          ...item,
          label: t('Products.filters.availableOnline'),
        },
      ],
    };
    return JSON.parse(
      JSON.stringify([customSellableFilter, ...filters.filter((filter) => filter.id !== sellableFilterId)]),
    );
  }

  return filters;
});

const emit = defineEmits(['onSortChanged', 'onFiltersChanged']);

const onFiltersInitialized = () => {
  filtersInitialized.value = true;
};

watch(
  () => query.value,
  () => {
    if (query.value && filtersInitialized.value && mixedGridFiltersRef.value) {
      mixedGridFiltersRef.value.removeAllFilters();
    }
  },
);
</script>

<template>
  <mixed-grid-filters
    ref="mixedGridFiltersRef"
    :sellable-filter-id="sellableFilterId"
    :default-sort="defaultSort"
    :filters="filters"
    :unique-id="id"
    :is-sticky="false"
    :products-count="productsCount"
    :should-display-products-count="false"
    :should-display-sellable="shouldDisplaySellable"
    :large="false"
    panel-id="search-results-products-filters"
    tight
    has-filters-in-url
    url-param-prefix="search"
    @on-sort-change="emit('onSortChanged', $event)"
    @on-filters-changed="emit('onFiltersChanged', $event)"
    @filters-initialized="onFiltersInitialized"
  ></mixed-grid-filters>
</template>
